import { SvgIcon, SvgIconProps } from '@mui/material';

export const TabBarOrderAheadFoodIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M0.199951 20.98C0.199951 21.54 0.649951 21.99 1.20995 21.99H14.2C14.76 21.99 15.21 21.54 15.21 20.98V20H0.199951V20.98ZM7.69995 7.99C3.94995 7.99 0.199951 10 0.199951 14H15.2C15.2 10 11.45 7.99 7.69995 7.99ZM2.81995 12C3.92995 10.45 6.28995 9.99 7.69995 9.99C9.10995 9.99 11.47 10.45 12.58 12H2.81995ZM0.199951 16H15.2V18H0.199951V16ZM17.2 4V0H15.2V4H10.2L10.43 6H19.99L18.59 20H17.2V22H18.92C19.76 22 20.45 21.35 20.55 20.53L22.2 4H17.2Z" />
    </SvgIcon>
  );
};
